import React from 'react';
import './style.scss';

const PopupExamFile = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-exam-file">
      <div className="popup-overlay" onClick={onClose}></div>
      <div className="popup-content">
        <button className="btn btn-icon" onClick={onClose}>
          <span className="icon icon-plus"></span>
        </button>
        {children}
      </div>
    </div>
  );
};

export default PopupExamFile;
